import React from "react"

const PageBanner = ({ pageTitle }) => {
  return (
    <div className="page-title-area">
      <div className="d-table">
        <div className="d-table-cell">
          <div className="container">
            <h1>{pageTitle}</h1>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PageBanner
